import codegen from 'codegen.macro';

codegen.require('./dynamicModuleCodegen.js');
